import '@babel/polyfill'
import { createApp } from 'vue'
import { Loading } from 'vant'
import App from './App.vue'
import router from './router'
import './styles/index.scss'
import 'vant/lib/index.css'

createApp(App).use(router).use(Loading).mount('#app')
